import React, { FunctionComponent } from 'react';

export const AddSVG: FunctionComponent = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="#F0F0F0"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21.1766 9.14286H14.8571V2.82343C14.8571 1.27086 13.5531 0 12 0C10.4469 0 9.14286 1.27086 9.14286 2.82343V9.14286H2.82343C1.27086 9.14286 0 10.4469 0 12C0 13.5531 1.27086 14.8571 2.82343 14.8571H9.14286V21.1766C9.14286 22.7291 10.4469 24 12 24C13.5531 24 14.8571 22.7291 14.8571 21.1766V14.8571H21.1766C22.7291 14.8571 24 13.5531 24 12C24 10.4469 22.7291 9.14286 21.1766 9.14286Z" />
    </svg>
  );
};
